module.exports = __webpack_public_path__ + "images/js-xp-coins.jpg";